import { useQuery } from '@apollo/client';

import { GET_USER_COGNITO_STATE } from '../data/queries/getUserCognitoState.gql';

export interface CognitoUserData {
  attributes: Array<{
    name: string;
    value: string;
  }>;
  groups: string[];
  status: string;
}

export interface CognitoStateData {
  __typename: string;
  status?: string;
  cognitoUsers?: {
    email?: CognitoUserData;
    phone?: CognitoUserData;
  };
  message?: string;
  responseType?: string;
}

export interface UseGetUserCognitoStateResult {
  cognitoState: CognitoStateData | null;
  loading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useGetUserCognitoState = (
  userId?: string
): UseGetUserCognitoStateResult => {
  const { data, loading, error, refetch } = useQuery(GET_USER_COGNITO_STATE, {
    variables: { id: userId },
    skip: !userId,
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  return {
    cognitoState: data?.userCognitoState || null,
    loading,
    error: error || null,
    refetch,
  };
};
